'use client'

import { useEffect, useState } from 'react'
import { fetchKitchenTransferTrips } from '@/features/delman/api/delmanKitchenTransferApi'
import { shouldUseDelmanMock } from '@/features/delman/api/delmanApiMode'
import { todayDateKey } from '@/features/kitchen/storage/attendanceStorage'

export function useKitchenTransferPending(enabled: boolean): number {
  const [count, setCount] = useState(0)

  useEffect(() => {
    if (!enabled || shouldUseDelmanMock()) {
      return
    }

    let cancelled = false

    const load = () => {
      void fetchKitchenTransferTrips(todayDateKey())
        .then((trips) => {
          if (cancelled) return
          const pending = trips.reduce(
            (sum, trip) =>
              sum + trip.transfers.filter((drop) => drop.status !== 'receiving_completed').length,
            0,
          )
          setCount(pending)
        })
        .catch(() => {
          if (!cancelled) setCount(0)
        })
    }

    load()
    const timer = window.setInterval(load, 30_000)
    return () => {
      cancelled = true
      window.clearInterval(timer)
    }
  }, [enabled])

  return count
}
